module.exports = __webpack_public_path__ + "img/minus.abc3a06e.svg";